import React from 'react'
import PropTypes from 'prop-types'
import { Panel, Margin, Text, Form, FormInput, Button } from 'shared/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory } from 'react-router-dom'
import { BottomNavigation } from '../../public/events/overview/components/bottomNavigation'
import { Global } from '@emotion/core'

import * as styles from './styles'

const AddressComponent = ({
	loggedEntity,
	form,
	onSubmit,
	getOptionLabel,
	getOptionValue,
	loadJurisdictions,
	initialValues
}) => {
	const history = useHistory()

	const handleBackClick = () => {
		history.push('/profile')
	}

	if (!loggedEntity) {
		return (
			<>
				{/* Mobile Header */}
				<div css={styles.mobileHeader}>
					<div css={styles.headerContainer}>
						<FontAwesomeIcon
							icon="arrow-left"
							css={styles.backArrow}
							onClick={handleBackClick}
						/>
						<div css={styles.titleContainer}>
							<Text size={16} bold css={styles.headerTitle}>
								Address Data
							</Text>
						</div>
					</div>
				</div>

				<Panel css={styles.panel}>
					<div css={styles.contentWrapper}>
						<Text>Loading...</Text>
					</div>
				</Panel>

				<BottomNavigation />
			</>
		)
	}

	return (
		<>
			{/* Global styles for portal-rendered dropdown */}
			<Global styles={styles.portalMenuStyles} />

			{/* Mobile Header */}
			<div css={styles.mobileHeader}>
				<div css={styles.headerContainer}>
					<FontAwesomeIcon
						icon="arrow-left"
						css={styles.backArrow}
						onClick={handleBackClick}
					/>
					<div css={styles.titleContainer}>
						<Text size={16} bold css={styles.headerTitle}>
							Address Data
						</Text>
					</div>
				</div>
			</div>

			<Panel as={Form} form={form} onSubmit={onSubmit} css={styles.panel}>
				<div css={styles.contentWrapper}>
					<Margin bottom={5} css={styles.title}>
						<Text as="h1" size={18} bold>
							Address Data
						</Text>
					</Margin>

					<div css={styles.pageWrapper}>
						<div css={styles.formContent}>
							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>Country</Text>
								<div css={styles.countryInputContainer}>
									<div css={styles.inputWrapper}>
										<FormInput
											oldInput
											cacheOptions
											defaultOptions
											getOptionLabel={getOptionLabel}
											getOptionValue={getOptionValue}
											type="async-select"
											name="country"
											placeholder="Select your country"
											loadOptions={loadJurisdictions}
											fluid
											bordered
											menuPortalTarget={document.body}
											menuPosition="absolute"
											menuShouldScrollIntoView={false}
										/>
									</div>
								</div>
							</Margin>

							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>Postal Code/ZIP Code</Text>
								<FormInput name="zip" placeholder="Postal or ZIP code" />
							</Margin>

							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>State/Province/Region</Text>
								<FormInput name="state" placeholder="State, province or region" />
							</Margin>

							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>City/Town</Text>
								<FormInput name="city" placeholder="City or town" />
							</Margin>

							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>Address Line 1</Text>
								<FormInput name="address1" placeholder="Street address, P.O. box" />
							</Margin>

							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>Address Line 2</Text>
								<FormInput name="address2" placeholder="Apartment, suite, unit, building, floor" />
							</Margin>

							<Margin bottom={2} top={3}>
								<Button medium css={styles.saveButton}>
									<Text css={styles.buttonText}>Save changes</Text>
								</Button>
							</Margin>
						</div>
					</div>
				</div>
			</Panel>

			<BottomNavigation />
		</>
	)
}

AddressComponent.propTypes = {
	loggedEntity: PropTypes.shape(),
	form: PropTypes.shape().isRequired,
	onSubmit: PropTypes.func.isRequired,
	getOptionLabel: PropTypes.func,
	getOptionValue: PropTypes.func,
	loadJurisdictions: PropTypes.func,
	initialValues: PropTypes.shape(),
}

export default AddressComponent 